export var PdfViewerPageEventType;
(function (PdfViewerPageEventType) {
    PdfViewerPageEventType["LoadStateChange"] = "[showpad-pdf-viewer-page] Load State Change";
    PdfViewerPageEventType["PreviewRenderStateChange"] = "[showpad-pdf-viewer-page] Preview Render State Change";
    PdfViewerPageEventType["RenderStateChange"] = "[showpad-pdf-viewer-page] Render State Change";
    PdfViewerPageEventType["LayerRenderStateChange"] = "[showpad-pdf-viewer-page] Layer Render State Change";
    PdfViewerPageEventType["DimensionsChange"] = "[showpad-pdf-viewer-page] Dimensions Change";
    PdfViewerPageEventType["Reset"] = "[showpad-pdf-viewer-page] Reset";
})(PdfViewerPageEventType || (PdfViewerPageEventType = {}));
export class PdfViewerPageLoadStateChangeEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerPageEventType.LoadStateChange;
    }
}
export class PdfViewerPagePreviewRenderStateChangeEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerPageEventType.PreviewRenderStateChange;
    }
}
export class PdfViewerPageRenderStateChangeEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerPageEventType.RenderStateChange;
    }
}
export class PdfViewerPageLayerRenderStateChangeEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerPageEventType.LayerRenderStateChange;
    }
}
export class PdfViewerPageDimensionsChangeEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerPageEventType.DimensionsChange;
    }
}
export class PdfViewerPageResetEvent {
    constructor(payload) {
        this.payload = payload;
        this.type = PdfViewerPageEventType.Reset;
    }
}
//# sourceMappingURL=pdf-viewer-page-events.type.js.map